/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ext: NonNullable<unknown> }} Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs */



/**
* | output |
* | --- |
* | "Unsupported subtitle format: {ext}" |
*
* @param {Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_unsupported_format_error = /** @type {((inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Format de sous-titres non pris en charge : ${i?.ext}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Nicht unterstütztes Untertitelformat: ${i?.ext}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Formato sottotitoli non supportato: ${i?.ext}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Неподдерживаемый формат субтитров: ${i?.ext}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Formato de subtítulos no compatible: ${i?.ext}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`不支持的字幕格式：${i?.ext}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`サポートされていない字幕形式: ${i?.ext}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`असमर्थित उपशीर्षक प्रारूप: ${i?.ext}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Formato de legenda não suportado: ${i?.ext}`)
	return /** @type {LocalizedString} */ (`Unsupported subtitle format: ${i?.ext}`)
});